module.exports = __webpack_public_path__ + "static/media/Ordex-removebg.d86f111b.png";